let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("87cR5")).then(() => parcelRequire('23293'));